@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Pedidos</div>
        </div>
        <div class="d-flex flex-wrap flex-grow-1 justify-content-end">
          <a class="btn btn-secondary btn_titulo" routerLink="/pedidos-cadastro">Novo Pedido / Orçamento</a>
          <button class="btn btn-info btn_titulo" type="button" (click)="atualizar()">Atualizar</button>
        </div>
      </div>
    </div>
    <ul ngbNav #t="ngbNav" class="nav-tabs" (navChange)="alterarAbas($event)" [(activeId)]="tabSelecionada">
      <!-- Atenção -->
      <li [ngbNavItem]="'atencao'">
        <a ngbNavLink>
          <b>Atenção</b>
        </a>
        <ng-template ngbNavContent>
          <app-pedidos-atencao [configuracao]="configuracao"></app-pedidos-atencao>
        </ng-template>
      </li>
      <!-- Enviados -->
      <li [ngbNavItem]="'enviados'">
        <a ngbNavLink>
          <b>Enviados</b>
        </a>
        <ng-template ngbNavContent>
          <app-pedidos-enviados [configuracao]="configuracao"></app-pedidos-enviados>
        </ng-template>
      </li>
      <!-- Não Enviados -->
      <li [ngbNavItem]="'nao-enviados'">
        <a ngbNavLink>
          <b>Não Enviados</b>
        </a>
        <ng-template ngbNavContent>
          <app-pedidos-nao-enviados [configuracao]="configuracao"></app-pedidos-nao-enviados>
        </ng-template>
      </li>
      <!-- Pendências -->
      <li [ngbNavItem]="'pendencias'">
        <a ngbNavLink>
          <b>Pendências</b>
        </a>
        <ng-template ngbNavContent>
          <app-pedidos-pendencias [configuracao]="configuracao"></app-pedidos-pendencias>
        </ng-template>
      </li>
      <!-- Relatórios -->
      <li [ngbNavItem]="'relatorios'">
        <a ngbNavLink>
          <b>Relatórios</b>
        </a>
        <ng-template ngbNavContent>
          <app-pedidos-relatorios [configuracao]="configuracao"></app-pedidos-relatorios>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="t"></div>
  </div>
}
